import type { TFunction } from 'i18next';

const ERROR_KEYS: Record<string, string> = {
  access_denied: 'auth.googleAccessDenied',
  google_auth_failed: 'auth.googleSignInFailed',
  jwt_generation_failed: 'auth.googleJwtFailed',
  account_disabled: 'auth.googleAccountDisabled',
};

export function resolveOauthError(
  t: TFunction,
  errorCode: string | null,
  message?: string | null,
): string {
  if (errorCode && ERROR_KEYS[errorCode]) {
    return t(ERROR_KEYS[errorCode]);
  }
  if (message) {
    return message;
  }
  if (errorCode) {
    return t('auth.googleSignInFailed');
  }
  return t('auth.googleSignInFailed');
}
